<template>
  <header class="container-fluid">
    <img class="logo" :src="assets.logo" alt="Langham">
    <div class="banner">
      <div class="banner-img">
        <img class="large-banner" :src="bannerDesktop" alt="">
        <img class="mobile-banner" :src="bannerMobile" alt="">
      </div>
      <div class="banner-text">
        <h3 class="title">{{ connected ? 'YOU ARE CONNECTED' : 'Connect With Us' }}</h3>
      </div>
    </div>
  </header>
</template>

<script>
import logo from '@/components/custom/_langham2026/assets/img/logo_en.svg';

export default {
  name: 'langham-header',
  props: {
    bannerDesktop: { type: String, required: true },
    bannerMobile: { type: String, required: true },
    connected: { type: Boolean, default: false },
  },
  data() {
    return {
      assets: { logo },
    };
  },
};
</script>
